var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultilineHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 24.5 32.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "house-search-2.3.3.1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,23H4V12.5a.5.5,0,0,0-1,0v11a.5.5,0,0,0,.5.5H8a.5.5,0,0,0,0-1Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.82,24a.5.5,0,0,0,.5-.5v-11a.5.5,0,0,0-1,0V23h-4a.5.5,0,0,0,0,1Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.16,12.37a.5.5,0,0,0,.34.13.49.49,0,0,0,.37-.16.5.5,0,0,0,0-.71L12.34,1.13a.52.52,0,0,0-.68,0L.16,11.63a.5.5,0,1,0,.68.74L12,2.18Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,3h3V6a.5.5,0,0,0,1,0V2.5a.5.5,0,0,0-.5-.5H16a.5.5,0,0,0,0,1Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,31.16H10.58V14.64a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5H24a.5.5,0,0,0,.5-.5A.5.5,0,0,0,24,31.16Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,29.19H12.5V12a.5.5,0,0,0-1,0V29.69a.5.5,0,0,0,.5.5H24a.5.5,0,0,0,.5-.5A.5.5,0,0,0,24,29.19Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.41,18.62a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v9a.5.5,0,0,0,.5.5H24a.5.5,0,0,0,0-1H14.41Z",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_shape",
    "data-name": "invisible shape"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultilineHouseIcon);
export default __webpack_public_path__ + "static/media/multiline_house_icon.ed587dabcd3a36278cc892e5cc38b93e.svg";
export { ForwardRef as ReactComponent };